import { DetailsStep } from "@/types/Navigation";

// Keyed by the first segment of the name a processor registers under, not by
// the API path the error arrives under. For a Field that segment is its
// ValidationGroupProvider name, or the field's own name when the group has
// none (donationSource: naming that group would prefix its store path).
const STEP_BY_PROCESSOR_PREFIX: Record<string, DetailsStep> = {
  cardSelector: DetailsStep.SelectCard,
  donationSource: DetailsStep.DonationInformation,
  personalDetails: DetailsStep.YourDetails,
  address: DetailsStep.YourAddress,
  bankDetails: DetailsStep.BankDetails,
  payment_methods: DetailsStep.PaymentType,
};

export function stepForProcessor(processorName?: string): DetailsStep | null {
  if (!processorName) return null;

  const [prefix] = processorName.split(".");

  return STEP_BY_PROCESSOR_PREFIX[prefix] ?? null;
}
